import React from "react";
import { Cancel } from "@mui/icons-material";

export default function CancelButton({ onClose }) {
  return (
    <button
      onClick={onClose}
      className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition-colors"
      aria-label="Close"
    >
      <Cancel />
    </button>
  );
}
